// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gNU1","left":"styles_left__1htvM","right":"styles_right__1XNjb","alert":"styles_alert__1aNsm"};